import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const authModule = {
    namespaced: true,
    state: {
        token: null,
        user: null
    },
    mutations,
    actions,
    getters
};

export default authModule;
